import { useState, useRef } from 'react';
import cn from 'bem-cn';

import { Switch, Stack, Divider, HighlightedText, Markdown, Video } from '../../UI';

import { PromptInfoBodyProps } from './PromptInfoBody.types';
import './PromptInfoBody.scss';
import { getGuideText, getSwitchOptions, PROMPT_TEXT } from './PromptInfoBody.helpers';
import { useVideoControl } from './PromptInfoBody.hooks';

const b = cn('prompt-info-body');

export const PromptInfoBody = (props: PromptInfoBodyProps) => {
    const { promptForExample, example, promptImage, exampleImage, exampleVideo, isMediaPrompt } = props.data;

    const [switchValue, setSwitchValue] = useState(PROMPT_TEXT);
    const videoRef = useRef<HTMLVideoElement>(null);

    const isPromptOption = switchValue === PROMPT_TEXT;
    const switchOptions = getSwitchOptions(isMediaPrompt);
    const guideText = getGuideText(isPromptOption);

    useVideoControl(videoRef, !isPromptOption && isMediaPrompt, exampleVideo);

    return (
        <Stack spacing={24} className={b()}>
            <Switch className={b('switch')} options={switchOptions} value={switchValue} onChange={setSwitchValue} />
            {!isMediaPrompt && (
                <>
                    <p className={b('guide')} dangerouslySetInnerHTML={{ __html: guideText }} />
                    <Divider />
                </>
            )}
            <Stack className={b('content')}>
                {promptImage && (
                    <img
                        className={b('image', { hidden: !isPromptOption || !isMediaPrompt })}
                        src={promptImage}
                        alt=""
                    />
                )}
                {exampleImage && (
                    <img
                        className={b('image', { hidden: isPromptOption || !isMediaPrompt })}
                        src={exampleImage}
                        alt=""
                    />
                )}
                {exampleVideo && isMediaPrompt && (
                    <Video
                        ref={videoRef}
                        className={b('video', { hidden: isPromptOption })}
                        src={exampleVideo}
                        poster={promptImage}
                        autoPlay
                        muted
                        loop
                        playsInline
                        disablePictureInPicture
                    />
                )}
                {((isPromptOption && promptForExample) || (!isPromptOption && example)) && (
                    <div className={b('text-content')}>
                        {isPromptOption ? (
                            <HighlightedText useMarkdown>{promptForExample}</HighlightedText>
                        ) : (
                            <Markdown>{example}</Markdown>
                        )}
                    </div>
                )}
            </Stack>
        </Stack>
    );
};
